import { render, staticRenderFns } from "./yuesao_order.vue?vue&type=template&id=f5243ed0&"
import script from "./yuesao_order.vue?vue&type=script&lang=js&"
export * from "./yuesao_order.vue?vue&type=script&lang=js&"
import style0 from "./yuesao_order.vue?vue&type=style&index=0&id=f5243ed0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports